import type {SearchQuery} from "../NvbsSearchEngineApi/interfaces";
import {LayoutType} from "./types";

export interface UrlState {
    search: SearchQuery,
    layout: LayoutType,
    detailIndex?: number,
}



export class SearchEngineUrlState {
    private static readonly debounceTimeout = 300;
    private static timeout: any | null = null;

    private static keys = {
        query: 'qr',
        category: 'ca',
        page: 'pn',
        limit: 'li',
        date_one: 'do',
        date_two: 'dt',
        terms: 'te',
        layout: 'lt',
        sort: 'so',
        ocr: 'ocr',
        detailIndex: 'di',
        exactSearch: 'es',
    }

    public static Get(): UrlState {
        const urlParams = new URLSearchParams(window.location.search);

        const search: SearchQuery = {
            query: '',
            category: '',
            page: 1,
            limit: 20,
            date_one: undefined,
            date_two: undefined,
            sort: undefined,
            ocr: true,
            exact_match: true,
        }



        const layout = urlParams.get(this.keys.layout) || this.getLocalStorage('layout') || LayoutType.Grid;


        if (urlParams.has(this.keys.query)) {
            search.query = urlParams.get(this.keys.query) || '';
        }
        if (urlParams.has(this.keys.category)) {
            search.category = urlParams.get(this.keys.category) || '';
        }
        if (urlParams.has(this.keys.page)) {
            search.page = parseInt(urlParams.get(this.keys.page) || '1');
        }

        search.limit = parseInt(urlParams.get(this.keys.limit) || this.getLocalStorage('limit') || '20');

        if (urlParams.has(this.keys.date_one)) {
            search.date_one = parseInt(urlParams.get(this.keys.date_one) || '0');
        }
        if (urlParams.has(this.keys.date_two)) {
            search.date_two = parseInt(urlParams.get(this.keys.date_two) || '0');
        }
        if (urlParams.has(this.keys.sort)) {
            search.sort = urlParams.get(this.keys.sort) || undefined;
        }

        if (urlParams.has(this.keys.terms)) {
            search.terms = JSON.parse(urlParams.get(this.keys.terms) || '{}');
        }
        if (urlParams.has(this.keys.ocr)) {
            search.ocr = urlParams.get(this.keys.ocr) === 'true';
        } else {
            search.ocr = true;
        }

        if (urlParams.has(this.keys.exactSearch)) {
            search.exact_match = urlParams.get(this.keys.exactSearch) === 'true';
        } else {
            search.exact_match = true;
        }

        let detailIndex: number | undefined = undefined;

        if (urlParams.has(this.keys.detailIndex)) {
            detailIndex = parseInt(urlParams.get(this.keys.detailIndex) || '0');
        }

        return {
            search: search,
            layout: layout as LayoutType,
            detailIndex: detailIndex,
        };
    }

    public static save(search: SearchQuery, layout: LayoutType, detailIndex?: number): void {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams();
        if (search.query) {
            urlParams.set(this.keys.query, search.query);
        }
        if (search.category) {
            urlParams.set(this.keys.category, search.category);
        }
        if (search.page) {
            urlParams.set(this.keys.page, search.page.toString());
        }
        if (search.limit) {
            urlParams.set(this.keys.limit, search.limit.toString());
            this.setLocalStorage('limit', search.limit.toString());
        }
        if (search.date_one) {
            urlParams.set(this.keys.date_one, search.date_one.toString());
        }
        if (search.date_two || search.date_two === 0) {
            urlParams.set(this.keys.date_two, search.date_two.toString());
        }
        if (search.terms) {
            const strTerms = JSON.stringify(search.terms);
            if (strTerms !== '{}') {
                urlParams.set(this.keys.terms, strTerms);
            }
        }
        if (search.sort) {
            urlParams.set(this.keys.sort, search.sort);
        }
        if (search.ocr === true) {
            urlParams.set(this.keys.ocr, 'true');
        } else {
            urlParams.set(this.keys.ocr, 'false');
        }
        if (search.exact_match) {
            urlParams.set(this.keys.exactSearch,'true');
        } else {
            urlParams.set(this.keys.exactSearch,'false');
        }
        if (layout) {
            urlParams.set(this.keys.layout, layout);
            this.setLocalStorage('layout', layout);
        }
        if (detailIndex) {
            urlParams.set(this.keys.detailIndex, detailIndex.toString());
        }
        url.search = urlParams.toString();
        window.history.pushState({}, '', url.toString());
    }

    // group the url changes so the back button works correctly
    public static debounce_save(search: SearchQuery, layout: LayoutType, detailIndex?: number): void {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.save(search, layout, detailIndex);
        }, this.debounceTimeout);
    }

    private static setLocalStorage = (key: string, value: any) => {
        try {
            localStorage.setItem
            (key, JSON.stringify(value));
        } catch (e) {
            console.error(`Error setting localStorage for key ${key}:`, e);
        }
    }

    private static getLocalStorage = (key: string): any => {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;
        } catch (e) {
            console.error(`Error getting localStorage for key ${key}:`, e);
            return null;
        }
    }
}
